export default {
    "confirm_modal": {
        "buttons": {
            "cancel": "Close",
            "confirm": "Confirm"
        }
    },
    "start": {
        "headline": "Welcome to OpenCal",
        "message": "Please use a user's personal link to book appointments."
    },
    "login": {
        "headline": "Login to OpenCal",
        "email": "Email Address",
        "password": "Password",
        "button": "Login",
        "reset_password": "Reset Password",
        "welcome_message": "Welcome back! Please enter your details.",
        "email_placeholder": "your{'@'}email.com",
        "password_placeholder": "••••••••",
        "otp": "Code from your authenticator app",
        "otp_placeholder": "123456",
        "otp_hint": "Please enter the six-digit code your authenticator app is showing right now.",
        "errors": {
            "invalid_credentials": "Login failed. Please check your credentials.",
            "two_factor_invalid": "The code is wrong or has expired. Please enter the current code.",
            "network_error": "A network error occurred. Please try again later.",
            "unknown_error": "An unknown error occurred."
        }
    },
    "password_request": {
        "headline": "Password Reset",
        "email": "Email Address",
        "submit_button": "Request Password",
        "message_requested": "If an account exists for this email, you will receive a link to reset your password.",
        "welcome_message": "Enter your email to receive a reset link."
    },
    "password_reset": {
        "headline": "Password Reset",
        "email": "Email Address",
        "password": "New Password",
        "password_repeat": "Repeat New Password",
        "submit_button": "Reset Password",
        "message_changed": "Your password has been successfully reset.",
        "welcome_message": "Please enter your new password below.",
        "errors": {
            "email_invalid": "Please enter a valid email address.",
            "password_dont_match": "The passwords do not match."
        }
    },
    "header": {
        "nav": {
            "dashboard": "Dashboard",
            "appointments": "Appointments",
            "logout": "Log Out",
            "account": "Account",
            "event_types": "Event Types",
            "availability": "Availabilities",
            "admin": "Administration"
        }
    },
    "account": {
        "headline": "My Account",
        "name": "Name",
        "email": "Email Address",
        "locale": "Language",
        "password": "Password",
        "teams": "Teams",
        "buttons": {
            "edit": "Edit"
        },
        "messages": {
            "saved_success": "Changes saved successfully.",
            "save_failed": "An error occurred. Please try again."
        },
        "form": {
            "title": "Edit Account Details",
            "given_name": "First Name",
            "family_name": "Last Name",
            "email": "Email Address",
            "locale": "Language",
            "buttons": {
                "cancel": "Cancel",
                "save": "Save"
            }
        },
        "caldav_accounts": "CalDAV Accounts",
        "caldav_auths": {
            "headline": "CalDAV Accounts",
            "buttons": {
                "edit": "Edit",
                "add": "Add Entry",
                "back": "Back",
                "log": "Log"
            },
            "create_modal": {
                "headline": "Add CalDAV"
            },
            "form": {
                "buttons": {
                    "save": "Save"
                },
                "fields": {
                    "base_uri": "CalDAV Calendar URL",
                    "username": "Username",
                    "password": "Password"
                },
                "success_message": "The entry has been saved."
            },
            "delete": {
                "confirm_headline": "Delete CalDAV Calendar Access?",
                "confirm_message": "Are you sure you want to delete this entry? All synchronized data will be removed.",
                "success_message": "The entry has been deleted."
            },
            "logs": {
                "headline": "CalDAV synchronization logs",
                "buttons": {
                    "back": "Back",
                },
                "item": {
                    "headline": "Sync-log details",
                    "table": {
                        "count_items": "Data records",
                        "datetime": "Date & time",
                        "error_message": "Error message",
                        "uri": "CalDAV URI",
                        "user": "CalDAV User",
                    }
                }
            }
        },
        "event_types": {
            "headline": "Event Types",
            "delete": {
                "messages": {
                    "success": "The event type has been successfully deleted."
                }
            },
            "form": {
                "fields": {
                    "name": "Name",
                    "slug": "Slug",
                    "location": "Location",
                    "description": "Description",
                    "duration": "Duration",
                    "minimum_notice": "Minimum notice (minutes)",
                    "booking_window": "Booking window (days)",
                    "buffer_before": "Buffer before (minutes)",
                    "buffer_after": "Buffer after (minutes)",
                    "max_bookings_per_day": "Maximum bookings per day",
                    "max_bookings_per_day_hint": "0 = unlimited. Counts every booking that day, including other event types.",
                    "languages": "Languages",
                    "default_language": "Default language",
                    "allow_guests": "Allow additional guests",
                    "sms_reminder": "Offer SMS reminders (requires a configured SMS webhook)",
                    "booking_fields": "Booking questions",
                    "field_label": "Question / label",
                    "field_type": "Field type",
                    "options": "Options (separate with |)",
                    "required": "Required field",
                    "meeting_provider": "Meeting Provider"
                },
                "messages": {
                    "success": "The event type has been successfully saved.",
                    "error": "An error occurred while saving the event type.",
                    "location_required": "Location is required for in-person meetings."
                    ,"language_required": "At least one language must be enabled."
                },
                "buttons": {
                    "add_field": "Add question",
                    "remove_field": "Remove"
                }
            },
            "modal": {
                "headline": "Event Type"
            }
        },
        "availability": {
            "headline": "Manage Availabilities",
            "modal": {
                "headline": "Create/Edit Availability"
            },
            "form": {
                "fields": {
                    "week_day": "Week Day",
                    "start_time": "Start Time",
                    "end_time": "End Time"
                },
                "buttons": {
                    "save": "Save"
                }
            },
            "buttons": {
                "add": "Add Entry"
            }
        }
    },
    "change": "change",
    "booking": {
        "index": {
            "intro": "Welcome to my scheduling page. Select an event type to schedule a meeting.",
            "intro_selected": "Choose a day and time for your appointment.",
            "minutes": "minutes",
            "event_type_not_found": "This appointment type does not exist. Please choose one below.",
            "select_event_type": "What can I help you with?",
            "format_video": "Video call",
            "event_type_label": "Appointment type",
            "with": "with",
            "duration_minutes": "{duration} min",
            "load_error": "Booking is temporarily unavailable. Please try again in a few minutes or email {email}.",
            "load_error_reload": "Reload",
            "no_event_types": "There are no bookable appointments at this address. Please check the link or email {email}."
        },
        "footer": {
            "source": "Source code (OpenCal)",
            "imprint": "Legal notice",
            "privacy": "Privacy"
        },
        "book_now": {
            "not_available": "{name} is not available on {date_string}. Please choose another day.",
            "available_timeslots": "Available Time Slots",
            "select_time": "Pick a time that works for you",
            "timezone_notice": "All times are German time.",
            "load_failed": "Available times could not be loaded. Please try again shortly or write to me at {email}.",
            "none_available": "There are no free slots for this appointment type in the next {days} days. Write to me at {email} and we will find a time.",
            "timezone_differs": "Your time zone ({local}) differs by {offset}. Please take that into account.",
            "morning": "Morning",
            "afternoon": "Afternoon"
        },
        "form": {
            "headline": "Book an Appointment",
            "fields": {
                "name": "Name",
                "given_name": "First name",
                "family_name": "Last name",
                "email": "Email Address",
                "phone": "Mobile number (optional)",
                "phone_hint": "If you enter it, I will remind you 24 hours before the appointment by text message instead of e-mail.",
                "sms_consent": "I would like to receive an SMS reminder and consent to my mobile number being used for this purpose.",
                "language": "Language for confirmation and appointment",
                "guests_add": "Invite another person",
                "guests": "Additional guests (optional, at most two)",
                "guest_n": "Email address of additional person {n}",
                "guest_placeholder": "name{'@'}example.com",
                "please_select": "Please select",
                "confirm": "I have read this notice",
                "location": "How would you like to join?",
                "location_hint": "You will receive the link by email after booking.",
                "provider_help": "Explanation for {name}",
                "message": "Message for {name} to prepare for the meeting",
                "name_placeholder": "Your full name",
                "email_placeholder": "your{'@'}email.com",
                "message_placeholder": "Anything {name} should know before the meeting?"
            },
            "summary": {
                "when": "Your appointment",
                "where": "Join the video call",
                "where_hint": "You will find the same link in the confirmation email and in the calendar entry.",
                "german_time": "German time"
            },
            "provider_info": {
                "jitsi_meet": "Opens in your browser, no account needed. It runs on my server in Germany; video and audio are not recorded.",
                "nextcloud_talk": "You join via a link, no account needed. The server is in Germany (Hetzner).",
                "google_meet": "Google service (USA). Works without a Google account: enter your name and ask to join, I will let you in."
            },
            "provider_short": {
                "jitsi_meet": "In the browser, no account · server in Germany",
                "nextcloud_talk": "Via link, no account · server in Germany",
                "google_meet": "Works without a Google account · Google service (USA)"
            },
            "required_legend": "Fields marked with * are required.",
            "google_notice": "I add your appointment to my Google Calendar – more in the {link}.",
            "google_notice_link": "privacy policy",
            "buttons": {
                "submit": "Confirm Booking",
                "reschedule": "Reschedule appointment",
                "cancel": "Cancel appointment"
            },
            "messages": {
                "success": "Your appointment is booked. The confirmation with the link is on its way – please check your spam folder if it does not arrive.",
                "error": "An error occurred. Please try again."
            },
            "validation": {
                "location_required": "Please choose how you would like to join.",
                "required": "Please complete this required field.",
                "email_invalid": "Please enter a valid email address.",
                "guests_too_many": "Please invite at most two other people. For larger groups, write to me at {email}."
            },
            "your_details": "Your details"
        },
        "cancel": {
            "headline": "Cancel Appointment",
            "headline_done": "Appointment cancelled",
            "already_cancelled": "This appointment has already been cancelled.",
            "confirm_message": "Are you sure you want to cancel this appointment?",
            "success_message": "Your appointment is cancelled. A confirmation is on its way by email.",
            "book_again": "Book a new appointment",
            "invalid": "This cancellation link is invalid or has expired. Please email {email}.",
            "error": "The cancellation did not go through. Please try again or email me.",
            "appointment": "Appointment",
            "day": "Day",
            "time": "Time",
            "buttons": {
                "cancel_appointment": "Cancel Appointment"
            }
        },
        "reschedule": {
            "headline": "Reschedule appointment",
            "current": "Current appointment",
            "new_time": "New appointment",
            "no_slots": "There is no suitable time available on this day.",
            "submit": "Confirm rescheduling",
            "success": "Your appointment has been rescheduled. You will receive an updated confirmation by email shortly.",
            "invalid": "This rescheduling link is invalid or has expired. Please email {email}.",
            "error": "The rescheduling did not go through. Please try again.",
            "slots_label": "Available times",
            "cancel_intro": "You cannot make the appointment at all?",
            "cancel_open": "Cancel the appointment instead"
        }
    },
    "dashboard": {
        "admin": {
            "index": {
                "headline": "Administration"
            },
            "users": {
                "headline": "Users",
                "buttons": {
                    "back": "Back",
                    "add": "Add user",
                },
                "modal": {
                    "headline": "Add User"
                },
                "form": {
                    "fields": {
                        "email": "Email address",
                        "given_name": "First name",
                        "family_name": "Last name"
                    },
                    "success_message": "The user has been successfully created."
                },
                "status": {
                    "enabled": "Enabled",
                    "disabled": "Disabled",
                    "success_message": "The user status has been successfully updated."
                },
                "delete": {
                    "confirm_headline": "Delete User?",
                    "confirm_message": "Are you sure you want to delete this user? This action cannot be undone.",
                    "success_message": "The user has been successfully deleted.",
                    "buttons": {
                        "delete": "Delete user"
                    }
                },
                "roles": {
                    "admin": "Admin",
                    "user": "User"
                }
            },
            "audit_logs": {
                "headline": "Audit Logs",
                "total": "Total: {total}",
                "buttons": {
                    "back": "Back"
                },
                "table": {
                    "id": "ID",
                    "action": "Action",
                    "user": "User",
                    "data": "Data",
                    "date": "Date",
                    "no_logs": "No logs found."
                },
                "pagination": {
                    "previous": "Previous",
                    "next": "Next",
                    "page_info": "Page {current}"
                }
            }
        },
        "appointments": {
            "index": {
                "headline": "Appointments"
            },
            "details": {
                "headline": "Appointment Details",
                "fields": {
                    "event_type": "Event Type",
                    "date_time": "Date & Time",
                    "participant_name": "Participant",
                    "participant_email": "Email Address",
                    "location": "Location"
                }
            }
        }
    },
    "weekdays": {
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday"
    },
    "meeting_providers": {
        "jitsi_meet": "Jitsi Meet",
        "nextcloud_talk": "Nextcloud Talk",
        "google_meet": "Google Meet",
        "in_person": "In-person"
    }
};
